<template>
    <div class="modal fade" id="modal_add_payment_expense" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">

        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.expense.payment.title') }}

                    </h5>
                    <button @click="closeModal('modal_add_payment_expense', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPaymentExpense">
                    <form class="forms-sample" @submit.prevent="submitForm">

                        <div class="row mb-3">
                            <div class="col-md-12">
                                <h4 class="title-h4">
                                    {{ i18n.t('views.clients.expense.payment.info') }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-5">

                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.title') }} </b>: {{
                                        expense?.title ?? '' }}

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.category_name') }} </b> :
                                    <span>{{ expense?.service?.category?.name ?? '' }}</span>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.service_name') }} </b>:
                                    <span>{{ expense?.service?.name ?? '' }}</span>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.total_amount') }} </b> :
                                    {{ expense?.total_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160">{{ i18n.t('tables.expense.total_amount_paid') }}
                                    </b> :
                                    {{ expense?.total_amount_paid ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1 mt-1">
                                    <b class="d-inline-block w-160"> {{ i18n.t('tables.expense.remaining_amount') }}
                                    </b> :
                                    {{ expense?.remaining_amount ?? 0 }} {{ i18n.t('symbole.currency.mad') }}
                                </div>
                            </div>
                        </div>


                        <hr>


                        <div class="row ">
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPaymentExpense.paymentDate"
                                        :label="i18n.t('tables.payment.paymentDate')" :v="v$.paymentDate"
                                        :disabled="false" :fixedDays="1" :isFixedDays="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPaymentExpense.paymentMethod"
                                    :placeholder="i18n.t('tables.payment.paymentMethod')"
                                    :arrayOptions="payment_methodsList" refs="paymentMethod" :v="v$.paymentMethod" />
                            </div>
                            <div v-if="requestPaymentExpense.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPaymentExpense.bankName"
                                    :placeholder="i18n.t('tables.payment.bankName')" :arrayOptions="bank_namesList"
                                    refs="bankName" :v="v$.bankName" />
                            </div>

                            <div v-if="requestPaymentExpense.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPaymentExpense.chequeName"
                                        :label="i18n.t('tables.payment.chequeName')" :v="v$.chequeName"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="requestPaymentExpense.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPaymentExpense.chequeNum"
                                        :label="i18n.t('tables.payment.chequeNum')" :v="v$.chequeNum"
                                        :disabled="false" />
                                </div>
                            </div>

                            <div v-if="requestPaymentExpense.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPaymentExpense.dueDate"
                                        :label="i18n.t('tables.payment.dueDate')" :v="v$.dueDate" :disabled="false"
                                        :fixedDays="1" :isFixedDays="false" />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestPaymentExpense.amount_paid"
                                        :label="i18n.t('tables.payment.amount_paid')" :v="v$.amount_paid"
                                        :disabled="false" />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary mr-2">
                                {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                            </button>
                            <button type="button" @click="emptyState()" class="btn btn-cancel">
                                {{ i18n.t('button.cancel') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, reactive, toRefs, Ref } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
import checkboxInput from "@/components/inputsValidation/checkboxInput.vue";
import inputTextarea from "@/components/inputsValidation/ReusableTextarea.vue";



/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, minLength, minValue, helpers, requiredIf } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';

/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { clubUUID, bank_names, payment_methods, singleExpense } from "@/shared/state";
import { usePayment } from "@/composables/payment/usePayment";
import { PaymentRequest, Payment } from "@/interfaces/payment";

export default defineComponent({
    components: { inputText, SingleSelect, checkboxInput, inputTextarea },
    name: "SomeComponent",
    props: {
    },
    emits: ['savedPayment'],
    setup(props, { emit }) {
        const expense = computed(() => singleExpense.data);
        const action = ref('add')
        const remaining_amount = ref(0)

        const requestPaymentExpense = ref<PaymentRequest>({

            id: null,
            amount_paid: null,
            paymentMethod: null,
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: null,
            paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            status: "paid",
            pack_id: null,
            subscription_id: null,
            member_subscription_id: null,
            clubUUID: clubUUID.value,
            memberUUID: null,
            reference_id: expense?.value?.id ?? null,
            reference_type: "expenses"
        });

        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const { closeModal } = useModal();

        const { regulationSubscription, isRequestPayment, errorPayment } = usePayment();

        // Validation 
        const rules = {
            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            reference_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },

            paymentMethod: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            paymentDate: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            bankName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentExpense?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeName: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentExpense?.value?.paymentMethod === 'Chèque bancaire'))
            },
            chequeNum: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentExpense?.value?.paymentMethod === 'Chèque bancaire'))
            },
            dueDate: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentExpense?.value?.paymentMethod === 'Chèque bancaire')),
            },

            amount_paid: {
                requiredIf: helpers.withMessage(i18n.t("validation.required"), requiredIf(() => requestPaymentExpense?.value?.paymentMethod !== null)),
                numeric,
                paidAmountValid: helpers.withMessage(
                    i18n.t("validation.amountExceededError"),
                    (value) => {
                        const numberValue = Number(value);
                        const TTamount = remaining_amount.value || 0
                        return numberValue !== null && numberValue <= TTamount;
                    }
                )
            }

        };
        const v$ = useVuelidate(rules, requestPaymentExpense as Ref<Required<PaymentRequest>>, { $scope: 'payment-icome' });

        /**
         * Add or edit Service
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await regulationSubscription(requestPaymentExpense.value).then((res) => {
                        if (res?.data) {
                            emit('savedPayment')
                            emptyState()
                        }

                    })

                }
            }
        }


        const emptyState = () => {
            action.value = 'add';
            requestPaymentExpense.value.id = null

            requestPaymentExpense.value.bankName = null
            requestPaymentExpense.value.chequeName = null
            requestPaymentExpense.value.chequeNum = null
            requestPaymentExpense.value.amount_paid = null
            requestPaymentExpense.value.dueDate = null
            requestPaymentExpense.value.paymentMethod = null
            requestPaymentExpense.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            v$.value.$reset();
            closeModal('modal_add_payment_expense', 'add')
        };






        watch(
            () => expense.value,
            (newValue) => {
                requestPaymentExpense.value.reference_id = expense?.value?.id ?? null
                remaining_amount.value = expense?.value?.remaining_amount ?? 0

            });



        return {
            expense,
            requestPaymentExpense,
            submitForm,
            emptyState,
            action,
            v$,
            i18n,
            bank_namesList,
            payment_methodsList,
            closeModal,
            remaining_amount,
            isRequestPayment
        };
    },
});
</script>
